import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { primaryChapterListActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { getLedgerList_action } from '../../../../../actions/admin_module_action/ledger_action/ledger_action';
import Pagination from "../../../../../utils/pagination";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { event } from "jquery";

class Exh_chapter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            primaryChapterId: '',
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterChildList: [],
            primaryChapterSub_ChildList1: [],
            level4DummyId: '',
        }
        // this.recordFour = this.recordFour.bind(this)
    }

    // On Component Load
    componentDidMount() {

        this.getFillList(primaryChapterListActionId, '', '', '', '', '');

    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === primaryChapterListActionId) {
                        console.log("primaryChapterListActionId 121212")
                        for (var i = 0; i < data.data['level2'].length; i++) {
                            data.data['level2'][i].isHighlight = false;
                        }
                        this.setState({
                            primaryChapterListData: data.data['primaryChapter'],
                            level0: data.data['level0'],
                            level2: data.data['level2'],
                            level3: data.data['level3'],
                            level4: data.data['level4'],
                            isLoading: false,
                        })
                    }


                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    handleClickSelectPrimaryChapter(data, id) {
        const { primaryChapterRadio, primaryChapterListData, level2 } = this.state
        data.IsSelect = !data.IsSelect
        // data.isChecked = !data.IsSelect
        var listData = [...primaryChapterListData]
        if (id != '') {
            for (var i = 0; i < listData.length; i++) {
                if (listData[i].ChapterID == id) {
                    this.setState({
                        selectedPrimaryChapterId: id,
                    })
                    listData[i].isChecked = true;
                } else {
                    listData[i].isChecked = false;
                }
            }
            console.log('updated list : ', listData);
            this.setState({
                primaryChapterListData: listData,
            })
            var lev2List = [...level2]
            for (var i = 0; i < lev2List.length; i++) {
                if (lev2List[i].ParentChapterID == id) {
                    lev2List[i]['isHighlight'] = true;
                } else {
                    lev2List[i]['isHighlight'] = false;
                }
            }
            this.setState({
                level2: lev2List,
            })
        }



        this.setState({ primaryChapterRadio: id })
        // primaryChapterListData.length > 0 && primaryChapterListData.map(data => {
        //     if (data.ChapterID == id) {
        //         data.IsSelect = !data.IsSelect
        //         this.setState({ primaryChapterListData : primaryChapterListData})

        //     }
        // })

    }

    // on check level 4
    onSelectLevel4(e, id, tempLevel4) {
        const { level4, exhibitDetailsList, level3, level2, level4DummyId } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level4: level4, exhibitDetailsTableErr: '' })
        }, 200);

        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < level2.length; j++) {
                    if (tempLevel4[i]['ChapterID'] == id) {
                        if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                            if (level2[j]['ChapterID'] == level3[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel4.every(item => item.IsSelect == 1)

                                if (allSelectedChecked) {
                                    level2[j]['IsSelect'] = true
                                    // level3[index]['IsSelect'] = true
                                }
                                else {
                                    level2[j]['IsSelect'] = false
                                    // level3[index]['IsSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }

        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                if (tempLevel4[i]['ChapterID'] == id) {
                    if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel4.every(item => item.IsSelect == 1)
                        console.log("id", id)
                        console.log("tempLevel4", tempLevel4)
                        if (allSelectedChecked) {
                            level3[index]['IsSelect'] = true
                        }
                        else {
                            level3[index]['IsSelect'] = false
                        }
                    }
                }

            }

        }


    }

    // on check level 2
    onCheckLevel2(e, id) {
        const { level2, primaryChapterChildList, primaryChapterSub_ChildList1 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['IsSelect'] = true

                    primaryChapterChildList.forEach((data) => {
                        if (level2[i]['ChapterID'] == data.ParentChapterID) {

                            data.IsSelect = true
                        }
                    });

                    primaryChapterChildList.forEach((data) => {
                        if (level2[i]['ChapterID'] == data.ParentChapterID) {
                            primaryChapterSub_ChildList1.map((item) => {
                                if (data.ChapterID == item.ParentChapterID) {
                                    item.IsSelect = true
                                }
                            })
                        }
                    });

                } else {
                    level2[i]['IsSelect'] = false

                    primaryChapterChildList.forEach((data) => {
                        if (level2[i]['ChapterID'] == data.ParentChapterID) {

                            data.IsSelect = false
                        }
                    });

                    primaryChapterChildList.forEach((data) => {
                        if (level2[i]['ChapterID'] == data.ParentChapterID) {
                            primaryChapterSub_ChildList1.map((item) => {
                                if (data.ChapterID == item.ParentChapterID) {
                                    item.IsSelect = false
                                }
                            })
                        }
                    });
                }

            }
        }
        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);
    }

    // on check level 3
    onCheckLevel3(e, id, tempLevel3) {
        const { level3, primaryChapterSub_ChildList1, level2, level4 } = this.state
        this.setState({ level4DummyId: id })
        const event = e.target.checked
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['IsSelect'] = true

                    primaryChapterSub_ChildList1.forEach((data) => {
                        if (level3[i]['ChapterID'] == data.ParentChapterID) {

                            data.IsSelect = true
                        }
                    });

                } else {
                    level3[i]['IsSelect'] = false
                    primaryChapterSub_ChildList1.forEach((data) => {
                        if (level3[i]['ChapterID'] == data.ParentChapterID) {

                            data.IsSelect = false
                        }
                    });

                }
            }
        }
        setTimeout(() => {
            this.setState({ level3: level3 })
        }, 200);


        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                    if (level3[i]['ChapterID'] == id) {
                        const allSelectedChecked = tempLevel3.every(item => item.IsSelect == 1)
                        console.log("level3", level3)
                        if (allSelectedChecked) {
                            level2[index]['IsSelect'] = true
                        }
                        else {
                            level2[index]['IsSelect'] = false
                        }
                    }
                }

            }

        }

    }

    // to call level third list 
    record(level2, level3, level4) {
        const { primaryChapterChildList } = this.state
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterChildList.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {
                                                    <input type="checkbox" className="from-left-sp"

                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordFour(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    // to call level four list
    recordFour(level3data, level4) {
        const { primaryChapterSub_ChildList1 } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterSub_ChildList1.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">
                                {/* level4data.IsCheckbox && */}
                                <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    render() {
        const { isLoading, primaryChapterListData, level2, level3, level4, parent_flag } = this.state


        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />

                    <div class="main-content">

                        <section style={{ marginTop: "85px" }}>
                            <div class="container-fluid">
                                <div className="asc" style={{ border: "1px solid #ddd" }}>
                                    <div
                                        className="card-header p-2 mb-2"
                                        style={{ padding: "9px!important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 14 }}>
                                            Select Primary Chapter
                                        </h3>
                                        {/* {<span className='text-danger text-start text-left d-block mt-1' style={{ marginLeft: '10px' }}>{primaryChapterIdErr}</span>} */}
                                    </div>

                                    <div
                                        className=""
                                        style={{ paddingLeft: 10, paddingRight: 10 }}
                                    >

                                        {
                                            primaryChapterListData.length > 0 && primaryChapterListData.map((data, i) => (
                                                <div className="form-row" key={i}>
                                                    <label key={i}>
                                                        <input type="radio" key={data.ChapterID}
                                                            name={i}
                                                            // select= {data.IsSelect}
                                                            checked={data.isChecked}
                                                            // value={data.isChecked}
                                                            onClick={e => this.handleClickSelectPrimaryChapter(data, data.ChapterID)}
                                                        />
                                                        {data.ChapterName}
                                                    </label>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 mt-4">
                                        <div className="asc" style={{ border: "1px solid #ddd" }}>
                                            <div
                                                className="card-header p-2 mb-2"
                                                style={{ padding: "9px!important" }}
                                            >
                                                <h3 className="card-title" style={{ fontSize: 14 }}>
                                                    Select Below Product
                                                </h3>
                                            </div>
                                            <div className="" style={{ paddingLeft: 10 }}>
                                                <form className="needs-validation pb-2" noValidate="">
                                                    <div className="form-row">
                                                        <div class="accordion" id="accordionExample">
                                                            {
                                                                level2.length > 0 && level2.map((level2Data, i) => (
                                                                    <>
                                                                        {
                                                                            // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                            <div class="accordion-item">
                                                                                <h2 class="accordion-header check-out" id={'heading_l1_' + level2Data.ChapterID}>

                                                                                    <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter  tit-name" : "accordion-button collapsed  tit-name"}
                                                                                        type="button"
                                                                                        data-bs-toggle="collapse"
                                                                                        data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                        aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                        {/* // checkbox for level2 */}
                                                                                        {
                                                                                            <input type="checkbox" className="from-left-sp check-out-in" name="" key={level2Data.ChapterID}
                                                                                                checked={level2Data.IsSelect}
                                                                                                onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)}
                                                                                            />
                                                                                        }
                                                                                        {level2Data.ChapterName}
                                                                                    </button>
                                                                                </h2>
                                                                                {this.record(level2Data, level3, level4)}
                                                                            </div>
                                                                        }

                                                                    </>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>

                </>

                {/* <Footerwithdr /> */}

            </>
        );
    }


}

export default withRouter(connect(null, { fill_action, getLedgerList_action })(Exh_chapter));